export enum FinalTaxesAssetTypeKey {
  REAL_ESTATE = 'real_estate',
  BANK_ACCOUNT = 'bank_account',
  OTHER_INVESTMENT = 'other_investment',
  BUSINESS_INTEREST = 'business_interest',
  ART_JEWELRY = 'art_jewelry'
}
